
$(document).ready(function() {
$(".navlink--cart").hover(
  function() {
    $('.browncart-Png').addClass("icon_hover");
  },
  function() {
    $('.browncart-Png').removeClass("icon_hover");
  }
);
});


$(document).on('click', '.playPauseBtn', function(){
var homevd = $(this).parents(".VideoCapture").children("video");
  homevd = homevd.get(0);
   if ( homevd.paused ) {
    $('video').each(function(){
      $(this).get(0).pause();
    });
    $(".playPauseBtn").each(function(){
      $(this).css('opacity','1');
    });    
   homevd.play();
   $(this).css('opacity','0');
  }else{
   homevd.pause();
   $(this).css('opacity','1');    
  }
})


$(document).on('click','.trickToPlay',function(e){

    if(!$(e.target).closest('.playPauseBtn').length > 0){
        if($(this).find('video').get(0).paused){
           $(this).find('video').get(0).play();
           $(this).find('video').siblings('.playPauseBtn').css('opacity','0');
        }else{
           $(this).find('video').get(0).pause();
           $(this).find('video').siblings('.playPauseBtn').css('opacity','1');
          
        }
    }
})


